import settings from "../utils/settings";
import SFError from "../models/SfError";
import { useDataProvider } from "ra-core";
const useEditMember = () => {
  const dataprovider = useDataProvider();
  const editMember = async ({ id, version, ...rest }) => {
    const { realmId, branchId, lang } = settings();

    try {
      const result = await dataprovider.update("members", {
        data: {
          id: id,
          locale: lang,
          realm_id: realmId,
          branch_id: branchId,
          ...rest,
          __v: version,
        },
      });

      return result;
    } catch (error) {
      const sfError = new SFError({ message: String(error) });
      return sfError.json();
    }
  };
  return { editMember };
};

export default useEditMember;
